export enum ShelterType {
    MASS_ACCOMMODATION = 'mass_accommodation',
    OWN_APARTMENT = 'own_apartment',
    ROOM = 'room',
    VILLA = 'villa'
}
